import { QueryListAction } from '../../../pillar/dashboard/store/actions/QueryListAction';
import { CalOmsExtractWorkspaceModel } from '../../models/CalOmsExtractWorkspaceModel';
import { CalOmsExtractWorkspaceFilterModel } from '../../models/CalOmsExtractWorkspaceFilterModel';
import { ExtractModel } from '../../models/ExtractModel';

export const GET_SELECTED_EXTRACT_ACTION = '[Extracts] Get Selected Extract Action';

export class GetSelectedExtractAction extends QueryListAction<CalOmsExtractWorkspaceModel> {
  constructor(module: string, modelType: { new(): CalOmsExtractWorkspaceModel; }, public payload: {
    key: string,
    page: number,
    pageSize: number,
    sort?: string,
    sortDirection?: string,
    searchTerm?: string,
    extractType: string,
    model?: ExtractModel,
    filterModel?: CalOmsExtractWorkspaceFilterModel,
  }) {
    super(module, modelType, payload);
  }
}



// WEBPACK FOOTER //
// ./src/app/extracts/store/actions/GetSelectedExtractAction.ts